import { render, staticRenderFns } from "./VoteList.vue?vue&type=template&id=0a84222c&scoped=true"
import script from "./VoteList.vue?vue&type=script&lang=js"
export * from "./VoteList.vue?vue&type=script&lang=js"
import style0 from "./VoteList.vue?vue&type=style&index=0&id=0a84222c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84222c",
  null
  
)

export default component.exports